
import React from 'react';
import SEO from '@/components/SEO';
import { Link } from 'react-router-dom';
import { CalendarIcon } from 'lucide-react';
import { Separator } from '@/components/ui/separator';

const BLOG_POSTS = [
  {
    slug: 'the-problem-with-ecommerce',
    title: 'The Problem with E-commerce',
    excerpt: 'Revenue keeps growing, the dashboards look fine, and then the financial results arrive. Why e-commerce businesses so often discover a loss too late, and how to see it while there is still time to act.',
    date: 'Updated October 2026'
  }
];

const Blog = () => {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <SEO
        title="Blog | Stratodata"
        description="Insights on retail analytics, data engineering, ecommerce automation and AI from the Stratodata team."
        canonical="/blog"
      />
      <div className="container-custom">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mt-8 mb-4">Blog</h1>
          <p className="text-lg text-muted-foreground mb-8">
            Our latest insights and thoughts on data science, automation, and industry trends.
          </p>
          
          <Separator className="my-8" />
          
          <div className="space-y-8">
            {BLOG_POSTS.map((post) => (
              <div key={post.slug} className="group">
                <Link to={`/blog/${post.slug}`} className="block">
                  <h2 className="text-2xl font-semibold mb-2 group-hover:text-primary transition-colors">
                    {post.title}
                  </h2>
                  <div className="flex items-center text-sm text-muted-foreground mb-3">
                    <CalendarIcon className="h-4 w-4 mr-1" />
                    <time dateTime={post.date}>{post.date}</time>
                  </div>
                  <p className="text-muted-foreground">{post.excerpt}</p>
                  <div className="mt-4 text-primary text-sm font-medium">
                    Read more →
                  </div>
                </Link>
                <Separator className="mt-8" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
